import { apiFetch } from './http';

// ── Types ──

export type LandingPageStatus = 'active' | 'provisioning' | 'inactive';

export interface LandingPage {
  slug: string;
  domain: string;
  baseDomain?: string;
  productId: string;
  description: string;
  s3Bucket: string;
  cfDistributionId: string;
  cfDomainName: string;
  status: LandingPageStatus;
  currentVersion: string;
  lastDeployAt: string;
  deployCount: number;
  createdAt: string;
  updatedAt?: string;
}

export interface DeployRecord {
  version: string;
  files: number;
  source: string;
  deployedBy: string;
  deployedAt: string;
}

export interface LandingPageDetail extends LandingPage {
  deployHistory: DeployRecord[];
}

export interface HealthCheckResult {
  slug: string;
  domain: string;
  code: number;
  latencyMs: number;
  error?: string;
  checkedAt: string;
}

// ── API Client ──


export async function fetchLandingPages(): Promise<{ landingPages: LandingPage[] }> {
  return apiFetch('/ops/landing-pages');
}

export async function fetchLandingPage(slug: string): Promise<LandingPageDetail> {
  return apiFetch(`/ops/landing-pages/${slug}`);
}

export async function registerLandingPage(input: {
  slug: string;
  productId: string;
  domain?: string;
  description?: string;
  s3Bucket?: string;
  cfDistributionId?: string;
  cfDomainName?: string;
  currentVersion?: string;
}): Promise<LandingPage> {
  return apiFetch('/ops/landing-pages', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function deployLandingPage(
  slug: string,
  input: { source?: string; files?: Record<string, string>; version?: string; deployedBy?: string }
): Promise<{ status: string; slug: string; version: string; files: number; invalidated: boolean }> {
  return apiFetch(`/ops/landing-pages/${slug}/deploy`, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function healthCheckLandingPage(slug: string): Promise<HealthCheckResult> {
  return apiFetch(`/ops/landing-pages/${slug}/health`, { method: 'POST' });
}
